import { graphql } from 'gatsby';

export { default } from './ListPage';

export const listPageQuery = graphql`
  query ListPageQuery($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        lists {
          title
          items {
            text_md
            text
            date
            subtext_md
            subtext
          }
        }
      }
    }
  }
`;
